module.exports = __webpack_public_path__ + "assets/Cleaver.c0af2f014dc0ce45993806ea63528d5b.gmt";


//////////////////
// WEBPACK FOOTER
// ./src/resources/levels/Gmt/Cleaver.gmt
// module id = 931
// module chunks = 0